import { render, staticRenderFns } from "./rechargePolicy.vue?vue&type=template&id=72fc74ff&scoped=true"
import script from "./rechargePolicy.vue?vue&type=script&lang=js"
export * from "./rechargePolicy.vue?vue&type=script&lang=js"
import style0 from "./rechargePolicy.vue?vue&type=style&index=0&id=72fc74ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc74ff",
  null
  
)

export default component.exports